module.exports = __webpack_public_path__ + "static/media/BlackPumas-BlackMoonRising-500x250-Animated.42bd211e.mp4";